import { commandApi } from './commandApi';

export const GET_BANNER_DATA_COMMAND = 'get-web-client-announcement';

/**
 * @typedef {Object} AppBannerDataModel
 * @property {string | null} content
 * @property {number} expiresIn
 */

class AppBannerApi {

  /**
   * @return {Promise<AppBannerDataModel>}
   */
  getBannerData() {
    return commandApi.send(GET_BANNER_DATA_COMMAND);
  }

}

export const appBannerApi = new AppBannerApi();
